// extracted by mini-css-extract-plugin
export default {"image":"background__image__m3Rmf","color":"background__color__uf6iu","video":"background__video__Qpe2L","videoEnabled":"background__videoEnabled__WUFSE"};